import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';

export function useAddressData(applicantIndex: number, index: number, isCustomerApplicant: boolean) {
  const [formValues] = useFormValues();

  if (index === 0) {
    const addressFormatted = get(
      formValues,
      FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL_FORMATTED(applicantIndex)
    );
    const startDate = get(formValues, FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_START_DATE(applicantIndex));
    const applicantEntity = get(formValues, FIELD_PATHS.APPLICANT_ENTITY(applicantIndex), FIELD_VALUES.PERSON);
    const labels: { [key: string]: { [key: string]: string } } = {
      address: {
        [FIELD_VALUES.PERSON]: 'Current home address',
        [FIELD_VALUES.COMPANY]: 'Company registered address',
        [FIELD_VALUES.TRUST]: 'Trust registered address',
      },
      mailingAddress: {
        [FIELD_VALUES.PERSON]: 'Current mailing address',
        [FIELD_VALUES.COMPANY]: 'Company mailing address',
        [FIELD_VALUES.TRUST]: 'Trust mailing address',
      },
    };
    const addressFieldLabel = labels.address[applicantEntity];
    const mailingAddressFieldLabel = labels.mailingAddress[applicantEntity];

    return {
      headerData: { addressFormatted, startDate, isCurrent: true },
      addressFieldLabel: addressFieldLabel,
      addressFieldPath: FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL(applicantIndex),
      addressFieldName: FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL_FORMATTED(applicantIndex),
      mailingAddressFieldLabel: mailingAddressFieldLabel,
      mailingAddressFieldPath: FIELD_PATHS.APPLICANT_MAILING_ADDRESS(applicantIndex),
      mailingAddressFieldName: FIELD_PATHS.APPLICANT_MAILING_ADDRESS_FORMATTED(applicantIndex),
      housingStatusFieldLabel: 'Current living arrangement',
      housingStatusFieldName: FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_HOUSING_STATUS(applicantIndex),
      startDate: {
        name: FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_START_DATE(applicantIndex),
        label: 'Move in date',
      },
    };
  }

  const addressFormatted = get(
    formValues,
    FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_RESIDENTIAL_FORMATTED(applicantIndex, index - 1)
  );
  const startDate = get(formValues, FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_START_DATE(applicantIndex, index - 1));
  const endDate = get(formValues, FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_END_DATE(applicantIndex, index - 1));

  return {
    headerData: { addressFormatted, startDate, endDate, isCurrent: false },
    addressFieldLabel: 'Previous home address',
    addressFieldPath: FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_RESIDENTIAL(applicantIndex, index - 1),
    addressFieldName: FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_RESIDENTIAL_FORMATTED(applicantIndex, index - 1),
    housingStatusFieldLabel: 'Previous living arrangement',
    housingStatusFieldName: FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_HOUSING_STATUS(applicantIndex, index - 1),
    startDate: {
      name: FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_START_DATE(applicantIndex, index - 1),
      label: 'Move in date',
    },
    endDate: {
      name: FIELD_PATHS.APPLICANT_PREVIOUS_ADDRESS_END_DATE(applicantIndex, index - 1),
      label: 'Move out date',
    },
  };
}
